/**
 * Quotations contract, shared by the API and the web client. Kept in sync
 * with apps/api/src/modules/quotations/quotations.schemas.ts. Produced by
 * the `GENERATE_QUOTATION` automation action, the `COLLECT_QUOTATION`
 * conversation-flow step, or staff ("New Quotation"); staff can edit the
 * priced lines (`PUT /quotations/:id/items`).
 */
/** Rounds to 2 decimals (money). */
export function roundMoney(amount) {
    return Math.round((amount + Number.EPSILON) * 100) / 100;
}
/**
 * The one pricing rule for a quotation line, used by the API (persisted
 * totals, PDF) and the web editor (live preview) alike so they never drift.
 */
export function priceQuotationLine(line) {
    const discount = Math.min(Math.max(line.discountPercent ?? 0, 0), 100);
    // No discount keeps the price exact (catalog prices can carry 4
    // decimals), so undiscounted totals are what they always were.
    const discountedUnitPrice = discount > 0 ? roundMoney(line.unitPrice * (1 - discount / 100)) : line.unitPrice;
    const grossTotal = roundMoney(line.unitPrice * line.quantity);
    const lineTotal = roundMoney(discountedUnitPrice * line.quantity);
    return {
        discountedUnitPrice,
        grossTotal,
        lineTotal,
        discountAmount: roundMoney(grossTotal - lineTotal),
    };
}
export function quotationTotals(lines) {
    let grossAmount = 0;
    let totalAmount = 0;
    for (const line of lines) {
        const amounts = priceQuotationLine(line);
        grossAmount += amounts.grossTotal;
        totalAmount += amounts.lineTotal;
    }
    grossAmount = roundMoney(grossAmount);
    totalAmount = roundMoney(totalAmount);
    const discountAmount = roundMoney(grossAmount - totalAmount);
    return {
        grossAmount,
        discountAmount,
        totalAmount,
        averageDiscountPercent: grossAmount > 0 ? roundMoney((discountAmount / grossAmount) * 100) : 0,
    };
}
//# sourceMappingURL=quotations.js.map